/*
 * @Descripttion: actions
 * @Author: juanjuanhui
 * @Date: 2022-02-19 19:14:34
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-07 14:28:24
 */
import * as types from "./types";

const actions = {
  /**
   * @descripttion: 获取token
   * @Author: juanjuanhui
   * @Date: 2021-12-13 10:39:03
   */
  getAccesToken({ commit }, payload) {
    commit(types.GET_ACCESS_TOKEN, payload);
  },
  /**
   * @descripttion: 保存头部菜单路由
   * @Author: juanjuanhui
   * @Date: 2022-02-21 09:15:00
   * @param {*} commit
   * @param {*} payload
   */
  saveHeadMenuPath({ commit }, payload) {
    commit(types.SAVE_HEAD_MENU_PATH, payload);
  },
  changeSearchName({ commit }, payload) {
    commit(types.CHANGE_SEARCH_NAME, payload);
  },
};
export default actions;
